import React from 'react';

export default function QuizQuestionShimmer() {
  return <div role="status" aria-label="Loading question" className="quiz-question-shimmer">
    <span className="visually-hidden">Loading question...</span>
    <div aria-hidden="true">
      {[0, 1, 2].map((line) => <span key={line}
        className="dashboard-skeleton dashboard-skeleton--line qbank-practiceShimmer__questionLine" />)}
      <div className="qbank-options">
        {[0, 1, 2, 3].map((option) => <div key={option} className="qbank-option qbank-practiceShimmer__option">
          <span className="dashboard-skeleton dashboard-skeleton--icon qbank-practiceShimmer__optionBadge" />
          <span className="dashboard-skeleton dashboard-skeleton--line qbank-practiceShimmer__optionLine" />
        </div>)}
      </div>
    </div>
  </div>;
}
